<script setup lang="ts">
import Banner from './components/banner/index.vue';
import Information from './components/information/index.vue';
import EventCalendar from './components/EventCalendar.vue';
import Content from './components/content/index.vue';
import CommunityCard from './components/CommunityCard.vue';
import OperationCard from './components/OperationCard.vue';
import Footer from './components/Footer.vue';
import Sidebar from './components/Sidebar.vue';
import ScrollToTop from './components/ScrollToTop.vue';
import CommunityAchievements from './components/CommunityAchievements.vue';

const props = defineProps({
  options: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<template>
  <section class="bg-hex-fafafa">
    <Sidebar />
    <ScrollToTop />
    <div class="pb-124">
      <Banner />
    </div>
    <div class="container mt-48">
      <Information :is-column="props.options.Column == 1" />
    </div>
    <div class="mt-48">
      <EventCalendar />
    </div>
    <div class="container mt--56 pb-40">
      <div class="flex justify-between gap-x-32">
        <div class="flex-grow overflow-hidden rounded-6 bg-white">
          <Content />
        </div>
        <div class="w-376 flex-shrink-0">
          <CommunityCard />
          <CommunityAchievements v-if="props.options.CommunityAchievements == 1 " />
          <OperationCard v-if="props.options.OperationCard == 1" />
          <Footer />
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
</style>
